module.exports = __webpack_public_path__ + "img/close.b904d9ac.svg";